function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9602 8C10.748 8 8.95624 9.79 8.95624 12C8.95624 14.21 10.748 16 12.9602 16C15.1725 16 16.9643 14.21 16.9643 12C16.9643 9.79 15.1725 8 12.9602 8ZM21.9092 11C21.4487 6.83 18.1354 3.52 13.9612 3.06V1H11.9592V3.06C7.78506 3.52 4.47174 6.83 4.01128 11H1.94922V13H4.01128C4.47174 17.17 7.78506 20.48 11.9592 20.94V23H13.9612V20.94C18.1354 20.48 21.4487 17.17 21.9092 13H23.9713V11H21.9092ZM12.9602 19C9.08637 19 5.95323 15.87 5.95323 12C5.95323 8.13 9.08637 5 12.9602 5C16.8341 5 19.9673 8.13 19.9673 12C19.9673 15.87 16.8341 19 12.9602 19Z",
  fill: "#121212"
});

function SvgCenter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/Center.ca2686f4.svg";
export { ForwardRef as ReactComponent };